import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-location-bl.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-location-bl.component.scss?ngResource";
import * as JsonUtils from "@arcgis/core/geometry/support/jsonUtils";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ActivatedRoute } from "@angular/router";
import { AppControllerService } from "../../../../../app-controller.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { MapService } from "../../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import { BlService } from "../bl.service";
import { AlertType } from "../../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../../app.config";
import { AppRoutingConstants } from "../../../../../app-routing.constants";
import { UrlConstants } from "../../../../../shared/constants/url.constants";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { debounceTime, finalize } from "rxjs";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ViewApplicationLocationBlConstants } from "./view-application-location-bl.constants";
let ViewApplicationLocationBlComponent = class ViewApplicationLocationBlComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    route;
    appController;
    routerParamsService;
    recipientListService;
    modalService;
    changeDetectorRefs;
    mapService;
    requestStatusService;
    viewApplicationService;
    blService;
    active;
    propertiesForm;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    application;
    getTrueCentroid;
    selectedProperty;
    getApplicationsQuery;
    getApplicationSetPropertiesObservable;
    descriptionLabel1 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_3;
    descriptionLabel4 = ViewApplicationLocationBlConstants.DESCRIPTION_LABEL_4;
    validationMessages = ViewApplicationLocationBlConstants.VALIDATION_MESSAGES;
    erfNoControl = ViewApplicationLocationBlConstants.ERF_NO_CONTROL;
    subdivisionControl = ViewApplicationLocationBlConstants.SUBDIVISION_CONTROL;
    allotmentControl = ViewApplicationLocationBlConstants.ALLOTMENT_CONTROL;
    farmNoControl = ViewApplicationLocationBlConstants.FARM_NO_CONTROL;
    sgCodeControl = ViewApplicationLocationBlConstants.SG_CODE_CONTROL;
    addressControl = ViewApplicationLocationBlConstants.ADDRESS_CONTROL;
    erfNoTextPlaceHolder = ViewApplicationLocationBlConstants.ERF_NO_TEXT_PLACEHOLDER;
    subdivisionTextPlaceHolder = ViewApplicationLocationBlConstants.SUBDIVISION_TEXT_PLACEHOLDER;
    allotmentTextPlaceHolder = ViewApplicationLocationBlConstants.ALLOTMENT_TEXT_PLACEHOLDER;
    farmNoTextPlaceHolder = ViewApplicationLocationBlConstants.FARM_NO_TEXT_PLACEHOLDER;
    sgCodeTextPlaceHolder = ViewApplicationLocationBlConstants.SG_CODE_TEXT_PLACEHOLDER;
    addressTextPlaceHolder = ViewApplicationLocationBlConstants.ADDRESS_TEXT_PLACEHOLDER;
    ownerLabel = ViewApplicationLocationBlConstants.OWNER_LABEL;
    copyApplicantToOwnerLabel = ViewApplicationLocationBlConstants.COPY_APPLICANT_TO_OWNER_LABEL;
    removePropertyLabel = ViewApplicationLocationBlConstants.REMOVE_PROPERTY_LABEL;
    unitNumberLabel = ViewApplicationLocationBlConstants.UNIT_NUMBER_LABEL;
    shopNumberLabel = ViewApplicationLocationBlConstants.SHOP_NUMBER_LABEL;
    titleDeedNumberLabel = ViewApplicationLocationBlConstants.TITLE_DEED_NUMBER_LABEL;
    titleDeedDescriptionLabel = ViewApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_LABEL;
    accommodationNameLabel = ViewApplicationLocationBlConstants.ACCOMMODATION_NAME_LABEL;
    unitNumberControl = ViewApplicationLocationBlConstants.UNIT_NUMBER_CONTROL;
    shopNumberControl = ViewApplicationLocationBlConstants.SHOP_NUMBER_CONTROL;
    titleDeedNumberControl = ViewApplicationLocationBlConstants.TITLE_DEED_NUMBER_CONTROL;
    titleDeedDescriptionControl = ViewApplicationLocationBlConstants.TITLE_DEED_DESCRIPTION_CONTROL;
    accommodationNameControl = ViewApplicationLocationBlConstants.ACCOMMODATION_NAME_CONTROL;
    modalOptions = ViewApplicationLocationBlConstants.MODAL_OPTION;
    ownerDisableFilterBy = true;
    ownerDisableAdd = false;
    ownerDisableEditing = false;
    ownerGroups = [];
    getStepMetaObservableSubscription;
    mapComponent;
    isMapLoaded = false;
    selectedPropertySubscription;
    constructor(aflaModuleStrategyService, route, appController, routerParamsService, recipientListService, modalService, changeDetectorRefs, mapService, requestStatusService, viewApplicationService, blService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.route = route;
        this.appController = appController;
        this.routerParamsService = routerParamsService;
        this.recipientListService = recipientListService;
        this.modalService = modalService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
        this.blService = blService;
    }
    ngOnInit() {
        this.initForm();
        this.listenForRouteParamChange();
        this.subscribeToProperty();
        this.changeDetectorRefs.detectChanges();
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    ngOnDestroy() {
        this.mapService.actionPropertyEnabled = false;
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.getStepMetaObservableSubscription = this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
        });
    }
    loadMetadata(stepMeta) {
        this.getApplicationData();
    }
    getProperties() {
        let formArray = this.propertiesForm.get("properties");
        if (!formArray || formArray.controls.length === 0)
            formArray = new FormArray([]);
        return this.propertiesForm.get("properties");
    }
    getZones(propertyIndex) {
        return this.getProperties().controls[propertyIndex].get("zones");
    }
    updateRequiredFields(propertyIndex) {
        const propertyControl = this.getProperties().controls[propertyIndex];
        const erfNoControl = propertyControl.get(this.erfNoControl);
        const farmNoControl = propertyControl.get(this.farmNoControl);
        const subdivisionControl = propertyControl.get(this.subdivisionControl);
        if (erfNoControl.value !== undefined && erfNoControl.value !== null && erfNoControl.value.trim() !== "") {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.clearValidators();
            subdivisionControl.clearValidators();
            farmNoControl.setValue("");
            subdivisionControl.setValue("");
            farmNoControl.disable();
            subdivisionControl.disable();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        else if ((farmNoControl.value !== undefined && farmNoControl.value !== null && farmNoControl.value.trim() !== "") ||
            (subdivisionControl.value !== undefined && subdivisionControl.value !== null && subdivisionControl.value.trim() !== "")) {
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.clearValidators();
            erfNoControl.setValue("");
            erfNoControl.disable();
            erfNoControl.markAsUntouched();
        }
        else {
            erfNoControl.setValidators(Validators.required);
            farmNoControl.setValidators(Validators.required);
            subdivisionControl.setValidators(Validators.required);
            erfNoControl.enable();
            farmNoControl.enable();
            subdivisionControl.enable();
            erfNoControl.markAsUntouched();
            subdivisionControl.markAsUntouched();
            farmNoControl.markAsUntouched();
        }
        erfNoControl.updateValueAndValidity();
        farmNoControl.updateValueAndValidity();
        subdivisionControl.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnCopyApplicantToOwnerClicked(propertyIndex) {
        const applicant = this.aflaModuleStrategyService.form.get("applicantForm").get("applicantRecipient").value;
        const ownersFormControl = this.getProperties().controls[propertyIndex].get("owners");
        this.recipientListService.addRecipient(applicant, true, ownersFormControl, true);
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemovePropertyClicked(propertyIndex) {
        this.getProperties().removeAt(propertyIndex);
        this.changeDetectorRefs.detectChanges();
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    setNumberToDecimal(control, event) {
        //  sets number to two decimal places
        const value = event.target.value;
        const decimalValue = parseFloat(value).toFixed(2);
        control.setValue(decimalValue);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("propertiesForm");
        this.propertiesForm = form;
    }
    loadExistingProperty(property) {
        this.setPropertyData(property, property.geometry);
    }
    setPropertyData(propertyObject, geometry) {
        this.requestStatusService.showBusySpinner("GetPropertyDate");
        const sgCode = this.propertyDataAlternateColumnName(propertyObject, "SgCode", "sgcode");
        let found = false;
        this.getProperties().controls.forEach(item => {
            const check = item.get("sgCode").value;
            if (check === sgCode) {
                found = true;
                this.appController.showMessage(ViewApplicationLocationBlConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPropertyDate");
            }
        });
        if (!found) {
            const newProperty = new FormGroup({
                erfNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "ErfNo", "erfno"), [Validators.required]),
                subdivision: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "PtnNum", "ptnnum"), [Validators.required]),
                allotment: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Allotment", "allotment"), [Validators.required]),
                farmNo: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "FarmNo", "farmno"), [Validators.required]),
                sgCode: new FormControl(sgCode, [Validators.required]),
                address: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "Address", "address"), [Validators.required]),
                unitNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "UnitNumber", "unitnumber")),
                shopNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "shopNumber", "shopnumber")),
                titleDeedNumber: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "titleDeedNumber", "titledeednumber"), [Validators.required]),
                titleDeedDescription: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "titleDeedDescription", "titledeeddescription"), [Validators.required]),
                accommodationName: new FormControl(this.propertyDataAlternateColumnName(propertyObject, "accommodationName", "accommodationname")),
                geometry: new FormControl(geometry),
                centroid: new FormControl(null, [Validators.required]),
                zones: new FormArray([], [Validators.min(1)])
            });
            const proxyUrl = ApiProxyConstants.URL;
            const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
            const url = `${proxyUrl}?${gpToolUrl}`;
            const formData = new FormData();
            formData.append("f", "json");
            formData.append("geometryJSON", JSON.stringify(geometry));
            this.getTrueCentroid = this.viewApplicationService.getTrueCentroid(url, formData)
                .subscribe({
                next: (trueCentroidResponse) => {
                    newProperty.get("centroid").setValue(trueCentroidResponse.results[0].value);
                    this.getPropertyOwners(newProperty);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("GetPropertyDate");
                    this.appController.handleServerErrorMessage(ViewApplicationLocationBlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                }
            });
        }
    }
    getPropertyOwners(newProperty) {
        const propertyControl = this.getProperties();
        propertyControl.clear();
        propertyControl.push(newProperty);
        this.active = 0;
        this.updateRequiredFields(0);
        this.syncMapGeometries();
        this.requestStatusService.removeBusySpinner("GetPropertyDate");
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    syncMapGeometries() {
        const geometries = [];
        this.getProperties().controls.forEach(item => {
            const geom = item.get("geometry").value;
            if (geom !== null) {
                geometries.push(geom);
            }
        });
        if (geometries.length > 0) {
            this.mapComponent.addGeometriesOnMap(geometries, "Business licence graphics", true);
        }
    }
    subscribeToProperty() {
        this.selectedPropertySubscription = this.mapService.$selectedProperty.pipe(debounceTime(1000)).subscribe(property => {
            if (property !== null) {
                this.checkIfPropertyIsAlreadyLoaded(property);
            }
        });
    }
    checkIfPropertyIsAlreadyLoaded(property) {
        const title = "Replace property";
        const contentMessage = "An application can only have 1 property. Do you want to replace the current property?";
        const propertyControl = this.getProperties();
        if (propertyControl && propertyControl.length > 0) {
            const dialogRef = this.modalService.open(PopUpComponent, this.modalOptions);
            dialogRef.componentInstance.title = title;
            dialogRef.componentInstance.contentMessage = contentMessage;
            dialogRef.componentInstance.data = true;
            dialogRef.result.then((replaceData) => {
                if (replaceData) {
                    this.getProperties().clear();
                    this.mapComponent.clearGraphics("Business licence graphics");
                    this.setPropertyData(property.attributes, property.geometry);
                }
            });
        }
        else {
            this.setPropertyData(property.attributes, property.geometry);
        }
    }
    getApplicationData() {
        const params = {
            $filter: `jobId eq ${this.jobID} and moduleId eq ${this.moduleID}`,
            $expand: `properties`
        };
        this.getApplicationsQuery = this.aflaModuleStrategyService.getApplicationsQuery(params).subscribe((returnValue) => {
            const propertyControl = this.getProperties();
            propertyControl.clear();
            this.application = returnValue.value[0];
            this.application.properties.forEach(property => {
                const geometryArc = WktConverterUtils.ConvertWktToArcGisJson(property.shape, 102100);
                const geom = JsonUtils.fromJSON(geometryArc);
                const newProperty = new FormGroup({
                    property: new FormControl(property),
                    erfNo: new FormControl(property.erfNumber, [Validators.required]),
                    subdivision: new FormControl(property.subdivision, [Validators.required]),
                    allotment: new FormControl(property.allotment, [Validators.required]),
                    farmNo: new FormControl(property.farmNumber, [Validators.required]),
                    sgCode: new FormControl(property.sgCode, [Validators.required]),
                    address: new FormControl(property.address, [Validators.required]),
                    geometry: new FormControl(geom),
                    centroid: new FormControl(null, [Validators.required]),
                    unitNumber: new FormControl(property.unitNumber, [Validators.required]),
                    shopNumber: new FormControl(property.shopNumber, [Validators.required]),
                    titleDeedNumber: new FormControl(property.titleDeedNumber, [Validators.required]),
                    titleDeedDescription: new FormControl(property.titleDeedDescription, [Validators.required]),
                    accommodationName: new FormControl(property.accommodationName, [Validators.required]),
                });
                const proxyUrl = ApiProxyConstants.URL;
                const gpToolUrl = AppConfig.settings.arcGIS.servicesURL
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID
                    + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
                const url = `${proxyUrl}?${gpToolUrl}`;
                const formData = new FormData();
                formData.append("f", "json");
                formData.append("geometryJSON", JSON.stringify(geometryArc));
                const getTrueCentroid = this.viewApplicationService.getTrueCentroid(url, formData).pipe(finalize(() => {
                    getTrueCentroid.unsubscribe();
                })).subscribe({
                    next: (response) => {
                        newProperty.get("centroid").setValue(response.results[0].value);
                        propertyControl.push(newProperty);
                        this.active = propertyControl.length - 1;
                        this.changeDetectorRefs.detectChanges();
                        this.updateRequiredFields(propertyControl.length - 1);
                        if (this.isMapLoaded) {
                            this.syncMapGeometries();
                        }
                        this.changeDetectorRefs.detectChanges();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationBlConstants.TRUE_CENTROID, error, CRUDOperation.Get);
                    }
                });
            });
            if (this.isMapLoaded) {
                this.syncMapGeometries();
            }
            this.changeDetectorRefs.detectChanges();
        });
    }
    onBtnSaveClicked() {
        if (this.propertiesForm.valid) {
            const points = [];
            const properties = [];
            const propertiesArray = this.getProperties();
            for (const item of propertiesArray.controls) {
                const centroid = item.get("centroid").value;
                points.push(`(${centroid.x} ${centroid.y})`);
                const geometry = item.get("geometry").value;
                const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
                let property = null;
                if (item.get("property") !== null && item.get("property").value !== null) {
                    property = item.get("property").value;
                    property.address = item.get(this.addressControl).value;
                    property.allotment = item.get(this.allotmentControl).value;
                    property.erfNumber = item.get(this.erfNoControl).value;
                    property.farmNumber = item.get(this.farmNoControl).value;
                    property.sgCode = item.get(this.sgCodeControl).value;
                    property.subdivision = item.get(this.subdivisionControl).value;
                    property.unitNumber = item.get(this.unitNumberControl).value?.toString();
                    property.shopNumber = item.get(this.shopNumberControl).value;
                    property.titleDeedNumber = item.get(this.titleDeedNumberControl).value;
                    property.titleDeedDescription = item.get(this.titleDeedDescriptionControl).value;
                    property.accommodationName = item.get(this.accommodationNameControl).value;
                }
                else {
                    property = {
                        address: item.get(this.addressControl).value,
                        allotment: item.get(this.allotmentControl).value,
                        erfNumber: item.get(this.erfNoControl).value,
                        farmNumber: item.get(this.farmNoControl).value,
                        sgCode: item.get(this.sgCodeControl).value,
                        subdivision: item.get(this.subdivisionControl).value,
                        unitNumber: item.get(this.unitNumberControl).value?.toString(),
                        shopNumber: item.get(this.shopNumberControl).value,
                        titleDeedNumber: item.get(this.titleDeedNumberControl).value,
                        titleDeedDescription: item.get(this.titleDeedDescriptionControl).value,
                        accommodationName: item.get(this.accommodationNameControl).value,
                        updateGeometry: false,
                        shape: geometryJSON,
                        isDummy: false,
                        wkid: 102100
                    };
                }
                properties.push(property);
            }
            const params = {
                property: properties[0],
                applicationShape: `POINT ${points.join(", ")}`,
                applicationWkid: 102100
            };
            this.getApplicationSetPropertiesObservable =
                this.blService.getApplicationSetPropertiesObservable(this.application.id, params)
                    .subscribe({
                    next: () => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationLocationBlConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ActivatedRoute },
        { type: AppControllerService },
        { type: RouterParamsService },
        { type: RecipientListService },
        { type: NgbModal },
        { type: ChangeDetectorRef },
        { type: MapService },
        { type: RequestStatusService },
        { type: ViewApplicationService },
        { type: BlService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
ViewApplicationLocationBlComponent = __decorate([
    Component({
        selector: "app-view-application-location-bl",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewApplicationLocationBlComponent);
export { ViewApplicationLocationBlComponent };
